import { c as _c } from "react/compiler-runtime";
import { Box, Flex, VStack } from "@styled-system/jsx";
import Link from "next/link";
import { CopyRightComponent } from "@/components/common/copyRight.common";
import { FieldInfo } from "@/components/custom/common/field-info";
import { LockIcon } from "@/components/icon";
import { Input } from "@/components/primitives/input";
import { Heading, Paragraph } from "@/components/primitives/typography";
import { NoiOSAlert } from "@/components/ios.warning";
import { ButtonV2 } from "../../primitives/buttonV2";
import type { TLoginData, TLoginForm } from "@/types/auth.type";
import type { AnyFieldApi } from "@tanstack/react-form";
import { css } from "@styled-system/css";
type TLoginComponentProps = {
  form: TLoginForm;
};
export const LoginComponent = props => {
  const $ = _c(31);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NoiOSAlert />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <VStack gap={1} align="center"><Heading level={3} variant="stylized">WELCOME BACK!</Heading><Heading level={3} variant="stylized">ENTER YOUR INFO BELOW TO</Heading><Heading level={3} variant="stylized">ACCESS YOUR DASHBOARD</Heading></VStack>;
    t2 = {
      width: "100%"
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props.form) {
    t3 = e => {
      e.preventDefault();
      e.stopPropagation();
      props.form.handleSubmit();
    };
    $[3] = props.form;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      width: "100%"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      onChange: _temp,
      onChangeAsyncDebounceMs: 500,
      onChangeAsync: _temp3
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props.form.Field) {
    t6 = <props.form.Field name="email" validators={t5}>{_temp4}</props.form.Field>;
    $[7] = props.form.Field;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LockIcon width={30} height={35} />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      onChange: _temp5,
      onChangeAsyncDebounceMs: 500,
      onChangeAsync: _temp7
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== props.form.Field) {
    t9 = <props.form.Field name="password" validators={t8}>{_temp8}</props.form.Field>;
    $[11] = props.form.Field;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t9) {
    t10 = <VStack gap={4} style={t4} align="center" justify="center">{t6}{t7}{t9}</VStack>;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== props.form.Subscribe) {
    t11 = <props.form.Subscribe selector={_temp9}>{_temp10}</props.form.Subscribe>;
    $[16] = props.form.Subscribe;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Link href="/forgotPassword"><Paragraph css={{
        fontFamily: "barlowCondensed",
        fontStyle: "italic",
        fontSize: "xl",
        letterSpacing: "normal",
        textDecoration: "underline",
        _hover: {
          color: "primary"
        }
      }}>Forgot Password?</Paragraph></Link>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11) {
    t13 = <VStack gap="2" width="100%" align="center">{t11}{t12}</VStack>;
    $[19] = t11;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t10 || $[22] !== t13) {
    t14 = <VStack gap={10}>{t10}{t13}</VStack>;
    $[21] = t10;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14 || $[25] !== t3) {
    t15 = <form style={t2} onSubmit={t3}>{t14}</form>;
    $[24] = t14;
    $[25] = t3;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Paragraph size="compact" css={{
      fontFamily: "Barlow Condensed",
      fontSize: "xl",
      fontWeight: "medium",
      textAlign: "center"
    }}>Want to host your own games?</Paragraph>;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <VStack align="center"><Box>{t16}<Link href="https://www.playjindo.com" target="_blank"><Paragraph css={{
            fontFamily: "Barlow Condensed",
            fontSize: "xl",
            fontWeight: "medium",
            textDecoration: "underline",
            textAlign: "center"
          }} size="compact">Learn more about Jindo</Paragraph></Link></Box><CopyRightComponent /></VStack>;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t15) {
    t18 = <Flex direction="column" justify="center" align="center" gap="14" pb="6" width="100%">{t0}{t1}{t15}{t17}</Flex>;
    $[29] = t15;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  return t18;
};
function _temp(t0) {
  const {
    value
  } = t0;
  if (!value) {
    return "Please Enter Email";
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(value)) {
    return "The input is not a valid E-mail!";
  }
}
function _temp2(resolve) {
  return setTimeout(resolve, 1000);
}
async function _temp3(t0) {
  const {
    value: value_0
  } = t0;
  await new Promise(_temp2);
  if (value_0.includes("error")) {
    return "No \"error\" allowed in email";
  }
}
function _temp4(field) {
  return <Box width="full"><Input size="lg"><Input.Text type="email" placeholder="Email" value={field.state.value} onBlur={field.handleBlur} onChange={e_0 => field.handleChange(e_0.target.value)} className={css({
        fontFamily: "barlow",
        fontWeight: "semibold",
        color: "black"
      })} /></Input><FieldInfo field={field} /></Box>;
}
function _temp5(t0) {
  const {
    value: value_1
  } = t0;
  if (!value_1) {
    return "Please Enter Password";
  }
}
function _temp6(resolve_0) {
  return setTimeout(resolve_0, 1000);
}
async function _temp7(t0) {
  const {
    value: value_2
  } = t0;
  await new Promise(_temp6);
  if (value_2.includes("error")) {
    return "No \"error\" allowed in password";
  }
}
function _temp8(field_0) {
  return <Box width="full"><Input size="lg"><Input.Text placeholder="Password" type="password" value={field_0.state.value} onBlur={field_0.handleBlur} onChange={e_1 => field_0.handleChange(e_1.target.value)} className={css({
        fontFamily: "barlow",
        fontWeight: "semibold",
        color: "black"
      })} /></Input><FieldInfo field={field_0} /></Box>;
}
function _temp9(state) {
  return [state.canSubmit, state.isSubmitting];
}
function _temp10(t0) {
  const [canSubmit, isSubmitting] = t0;
  return <ButtonV2 variant="primary" size="lg" type="submit" width="full" textStyle="uppercase" isLoading={isSubmitting} disabled={!canSubmit || isSubmitting} css={{
    fontSize: "2xl",
    letterSpacing: "normal"
  }}>Login To Your Account</ButtonV2>;
}